import React, { Component, Fragment } from 'react';
import AuthService from './services/AuthService'
import PropTypes from 'prop-types';
import { API } from 'aws-amplify';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ErrorIcon from '@material-ui/icons/Error';
import CheckIcon from '@material-ui/icons/CheckCircle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { phone, checkSquareO, yen, creditCard, tv } from 'react-icons-kit/fa/'
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SvgIcon from 'react-icons-kit';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import moment from 'moment';
import { withSnackbar } from 'notistack';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 300,
  },
  toggleContainer: {
    height: 56,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: "0 15px",
  },
  toggleButton: {
    width: 220,
    height: 40,
    border: 'solid 1px #ececec',
  },
  listItemIcon: {
    marginRight: 8
  },
});

const initialState = {
  reservationsTodayCheckedOut: [],
  reservationsBeforeCheckedOut: [],
  open: false,
  confirmReservationId: "",
  confirmInfomationReservationId : "",
  reservationOpen: false,
  babyM: "",
  babyW: "",
  kindergartenM: "",
  kindergartenW: "",
  elementarySchoolLowM: "",
  elementarySchoolLowW: "",
  elementarySchoolMiddleM: "",
  elementarySchoolMiddleW: "",
  elementarySchoolHighM: "",
  elementarySchoolHighW: "",
  juniorHighSchoolM: "",
  juniorHighSchoolW: "",
  highSchoolM: "",
  highSchoolW: "",
  universityM: "",
  universityW: "",
  twentiesM: "",
  twentiesW: "",
  thirtiesM: "",
  thirtiesW: "",
  fortiesM: "",
  fortiesW: "",
  fiftiesM: "",
  fiftiesW: "",
  sixtiesM: "",
  sixtiesW: "",
  overSeventiesM: "",
  overSeventiesW: "",
  planNote: "",
  customerNote: "",
  methodOfPaymentPlans: "",
  methodOfPaymentPlansDone: "no",
  methodOfPaymentOrders: "",
  existOrders: "yes",
  methodOfPaymentDrinks: "",
  drinksPrice: ""
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class CheckedOutManage extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
    this.authApi = new AuthService();
  }

  compare = (a, b) => {
    const dateA = a.date;
    const dateB = b.date;

    let comparison = 0;
    if (dateA > dateB) {
      comparison = -1;
    } else if (dateA < dateB) {
      comparison = 1;
    }
    return comparison;
  }

  componentWillMount(){

    this.authApi.isLogin()
    .then(
      (login) => {
        if(!login){
          this.props.history.push('/login');
        }
      }
    );

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-active-checked-in-reservations'; //replace this with the path you have configured on your API

    API.get(apiName, path).then(response => {
      console.log(response);
      response.reservations.sort(this.compare);

      let reservationsTodayCheckedOut = response.reservations.filter(function(item, index){
        if (moment(item.date).add(item.date_num,'days').format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) return true;
        return false;
      });

      let reservationsBeforeCheckedOut = response.reservations.filter(function(item, index){
        if (moment(item.date).add(item.date_num,'days').format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")) return true;
        return false;
      });

      this.setState({
        reservationsTodayCheckedOut : reservationsTodayCheckedOut,
        reservationsBeforeCheckedOut : reservationsBeforeCheckedOut,
      },() => {
        console.log("today: ", this.state.reservationsTodayCheckedOut)
        console.log("before: ",this.state.reservationsBeforeCheckedOut)
      });
    }).catch(error => {
      console.log(error);
    })
  }

  checkout = () => {
    const { enqueueSnackbar } = this.props;

    let methodOfPaymentPlans = this.state.methodOfPaymentPlans
    let methodOfPaymentOrders = this.state.methodOfPaymentOrders
    let methodOfPaymentDrinks = this.state.methodOfPaymentDrinks
    let drinksPrice = this.state.drinksPrice

    if(methodOfPaymentPlans === "" || methodOfPaymentOrders === "" || methodOfPaymentDrinks === "" || drinksPrice === ""){
      enqueueSnackbar("未入力の項目があります", {variant : 'error'})
    }else if(Number(drinksPrice) < 0) {
      enqueueSnackbar("金額に不正な値が入力されています", {variant : 'error'})
    }else{

      let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
      let path = '/checkout'; //replace this with the path you have configured on your API

      let body = {
        reservationId : this.state.confirmReservationId,
        methodOfPaymentPlans: this.state.methodOfPaymentPlans,
        methodOfPaymentOrders: this.state.methodOfPaymentOrders,
        methodOfPaymentDrinks: this.state.methodOfPaymentDrinks,
        drinksPrice: this.state.drinksPrice
      };

      let myInit = {
        body: body, // replace this with attributes you need
      }

      API.post(apiName, path, myInit).then(response => {
        console.log(response)

        let confirmReservationId = this.state.confirmReservationId;

        if(this.state.confirmReservationIdToday){

          let reservationsTodayCheckedOut = this.state.reservationsTodayCheckedOut.filter(function(item, index){
            if (item.reservation_id !== confirmReservationId) return true;
            return false;
          });

          this.setState({
            open: false,
            confirmReservationId: "",
            confirmReservationIdToday: null,
            reservationsTodayCheckedOut: reservationsTodayCheckedOut,
            methodOfPaymentPlans: "",
            methodOfPaymentPlansDone: "no",
            methodOfPaymentOrders: "",
            existOrders: "yes",
            methodOfPaymentDrinks: "",
            drinksPrice: ""
          });

        }else{
          let reservationsBeforeCheckedOut = this.state.reservationsBeforeCheckedOut.filter(function(item, index){
            if (item.reservation_id !== confirmReservationId) return true;
            return false;
          });

          this.setState({
            open: false,
            confirmReservationId: "",
            confirmReservationIdToday: null,
            reservationsBeforeCheckedOut: reservationsBeforeCheckedOut,
            methodOfPaymentPlans: "",
            methodOfPaymentPlansDone: "no",
            methodOfPaymentOrders: "",
            existOrders: "yes",
            methodOfPaymentDrinks: "",
            drinksPrice: ""
          });
        }
        enqueueSnackbar(response.message, {variant : 'success'});
      }).catch(error => {
        console.log(error)
        if(error.message){
          enqueueSnackbar(error.message, {variant : 'error'})
        }else{
          enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
        }
      });
    }
  }

  handleClickOpen = (reservationId, today, paid, existOrders) => {
    let methodOfPaymentPlansDone = "no"
    let methodOfPaymentPlans = ""
    if(paid ===  "yes"){
      methodOfPaymentPlans = "online"
      methodOfPaymentPlansDone = "yes"
    }

    let methodOfPaymentOrders = ""

    if(existOrders ===  "no"){
      methodOfPaymentOrders = "cash"
    }

    this.setState({
      open: true,
      confirmReservationId: reservationId,
      confirmReservationIdToday: today,
      methodOfPaymentPlans: methodOfPaymentPlans,
      methodOfPaymentPlansDone: methodOfPaymentPlansDone,
      methodOfPaymentOrders: methodOfPaymentOrders,
      existOrders: existOrders,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
      confirmReservationId: "",
      confirmReservationIdToday: null,
      methodOfPaymentPlans: "",
      methodOfPaymentPlansDone: "no",
      methodOfPaymentOrders: "",
      existOrders: "yes",
      methodOfPaymentDrinks: "",
      drinksPrice: ""
    });
  };

  handleCloseReservation = () => {
    this.setState({
      reservationOpen: false,
      confirmInfomationReservationId: "",
    });
  };

  handleReservationOpen = (reservationId) => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-additional-info'; //replace this with the path you have configured on your API

    let body = {
      reservationId : reservationId,
    };

    let myInit = {
        body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)

      this.setState({
        confirmInfomationReservationId : reservationId,
        reservationOpen: true,
        babyM: response.reservation.baby_m ? response.reservation.baby_m : "",
        babyW: response.reservation.baby_w ? response.reservation.baby_w : "",
        kindergartenM: response.reservation.kindergarten_m ? response.reservation.kindergarten_m : "",
        kindergartenW: response.reservation.kindergarten_w ? response.reservation.kindergarten_w : "",
        elementarySchoolLowM: response.reservation.elementary_school_low_m ? response.reservation.elementary_school_low_m : "",
        elementarySchoolLowW: response.reservation.elementary_school_low_w ? response.reservation.elementary_school_low_w : "",
        elementarySchoolMiddleM: response.reservation.elementary_school_middle_m ? response.reservation.elementary_school_middle_m : "",
        elementarySchoolMiddleW: response.reservation.elementary_school_middle_w ? response.reservation.elementary_school_middle_w : "",
        elementarySchoolHighM: response.reservation.elementary_school_high_m ? response.reservation.elementary_school_high_m : "",
        elementarySchoolHighW: response.reservation.elementary_school_high_w ? response.reservation.elementary_school_high_w : "",
        juniorHighSchoolM: response.reservation.junior_high_school_m ? response.reservation.junior_high_school_m : "",
        juniorHighSchoolW: response.reservation.junior_high_school_w ? response.reservation.junior_high_school_w : "",
        highSchoolM: response.reservation.high_school_m ? response.reservation.high_school_m : "",
        highSchoolW: response.reservation.high_school_w ? response.reservation.high_school_w : "",
        universityM: response.reservation.university_m ? response.reservation.university_m : "",
        universityW: response.reservation.university_w ? response.reservation.university_w : "",
        twentiesM: response.reservation.twenties_m ? response.reservation.twenties_m : "",
        twentiesW: response.reservation.twenties_w ? response.reservation.twenties_w : "",
        thirtiesM: response.reservation.thirties_m ? response.reservation.thirties_m : "",
        thirtiesW: response.reservation.thirties_w ? response.reservation.thirties_w : "",
        fortiesM: response.reservation.forties_m ? response.reservation.forties_m : "",
        fortiesW: response.reservation.forties_w ? response.reservation.forties_w : "",
        fiftiesM: response.reservation.fifties_m ? response.reservation.fifties_m : "",
        fiftiesW: response.reservation.fifties_w ? response.reservation.fifties_w : "",
        sixtiesM: response.reservation.sixties_m ? response.reservation.sixties_m : "",
        sixtiesW: response.reservation.sixties_w ? response.reservation.sixties_w : "",
        overSeventiesM: response.reservation.over_seventies_m ? response.reservation.over_seventies_m : "",
        overSeventiesW: response.reservation.over_seventies_w ? response.reservation.over_seventies_w : "",
        planNote: response.reservation.plan_note ? response.reservation.plan_note : "",
        customerNote: response.reservation.customer_note ? response.reservation.customer_note : "",
      })

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });

  }

  handleChange = (event, key) => {
    this.setState({
      [key] : event.target.value
    },() => {
      if(this.state.drinksPrice === '0'){
        this.setState({
          methodOfPaymentDrinks: 'cash'
        })
      }
    })
  }

  handleToggle = (event, methodOfPayment, key) => {
    this.setState({ [key]: methodOfPayment });
  }

  updateReservatiion = (event) => {
    console.log("event", event)

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/update-additional-info'; //replace this with the path you have configured on your API

    let body = {
      ...this.state
    };

    let myInit = {
      body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)

      this.setState({
        reservationOpen: false,
        confirmInfomationReservationId: "",
      });

      enqueueSnackbar(response.message, {variant : 'success'});

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });


  }

  render() {
    const {classes} = this.props
    const {
      reservationsTodayCheckedOut,
      reservationsBeforeCheckedOut,
      reservationOpen,
      scroll,
      babyM,
      babyW,
      kindergartenM,
      kindergartenW,
      elementarySchoolLowM,
      elementarySchoolLowW,
      elementarySchoolMiddleM,
      elementarySchoolMiddleW,
      elementarySchoolHighM,
      elementarySchoolHighW,
      juniorHighSchoolM,
      juniorHighSchoolW,
      highSchoolM,
      highSchoolW,
      universityM,
      universityW,
      twentiesM,
      twentiesW,
      thirtiesM,
      thirtiesW,
      fortiesM,
      fortiesW,
      fiftiesM,
      fiftiesW,
      sixtiesM,
      sixtiesW,
      overSeventiesM,
      overSeventiesW,
      planNote,
      customerNote,
      methodOfPaymentPlans,
      methodOfPaymentPlansDone,
      methodOfPaymentOrders,
      existOrders,
      methodOfPaymentDrinks,
      drinksPrice
    } = this.state;

    return (
      <Fragment>
        <Grid container spacing={24} className={classes.container}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              チェックアウト管理
            </Typography>
          </Grid>
          <Grid item>

            <Typography variant="h6" gutterBottom　style={{display: reservationsTodayCheckedOut.length === 0 && reservationsBeforeCheckedOut.length === 0  ? "" : "none"}}>
              表示する予約がありません
            </Typography>

            <Paper className={classes.root} elevation={1} style={{display: reservationsTodayCheckedOut.length === 0 ? "none" : ""}}>
              <Typography variant="h5" gutterBottom>
                本日チェックアウト予定の予約
              </Typography>
              <Table className={classes.table} style={{marginTop: 20}}>
                <TableHead style={{backgroundColor:"#f3f3f3"}}>
                  <TableRow>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">宿泊開始日</TableCell>
                    <TableCell style={{color: "#676767"}} align="right" padding="dense">泊数</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">お部屋</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">お名前</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">領収書発行</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reservationsTodayCheckedOut.map(n =>
                    {
                      let rooms = "";
                      for(let i in n.input_rooms){
                        rooms = rooms + n.input_rooms[i]
                        if(i !== n.input_rooms.length - 1){
                          rooms = rooms + " "
                        }
                      }
                      return (
                        <TableRow key={n.reservation_id}>
                          <TableCell align="center" padding="dense">{n.date}</TableCell>
                          <TableCell align="right" padding="dense">{n.date_num}</TableCell>
                          <TableCell align="center" padding="dense">{rooms}</TableCell>
                          <TableCell align="center" padding="dense">{n.last_name} {n.first_name} <div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div></TableCell>
                          <TableCell align="center" padding="dense">

                            {(() => {
                               if (n.receipt_numbers.length > 0){
                                 return (
                                   <Typography color="primary" variant="body2" style={{display: "inline-flex", verticalAlign:"middle", marginTop:0}}>
                                     <CheckIcon style={{marginLeft: 0, marginTop: -1, marginRight:5}} />済
                                   </Typography>
                                 )
                               }else{
                                 return (
                                   <Typography color="error" variant="body2" style={{display: "inline-flex", verticalAlign:"middle", marginTop:0}}>
                                     <ErrorIcon style={{marginLeft: 0, marginTop: -1, marginRight:5}} />未
                                   </Typography>
                                 )
                               }
                             })()}

                          </TableCell>
                          <TableCell align="center" padding="dense">

                            <Button
                              type="submit"
                              variant="contained"
                              color="default"
                              className={classes.button}
                              onClick={() => this.handleReservationOpen(n.reservation_id)}
                              style={{marginBottom:15,marginTop:5}}
                            >
                              <ListItemIcon><SvgIcon size={18} icon={phone}/></ListItemIcon>
                              付加情報入力　
                            </Button>
                            <br/>
                            <Button
                              type="submit"
                              variant="contained"
                              color="default"
                              className={classes.button}
                              onClick={() => this.handleClickOpen(n.reservation_id, true, n.jalan_paid, n.exist_orders)}
                              style={{marginBottom:5}}
                            >
                              <ListItemIcon><SvgIcon size={18} icon={checkSquareO}/></ListItemIcon>
                              チェックアウト
                            </Button>

                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
            <Paper className={classes.root} elevation={1} style={{marginTop:40, display: reservationsBeforeCheckedOut.length === 0 ? "none" : ""}}>
              <Typography variant="h5" gutterBottom>
                本日以前にチェックアウト予定の予約
              </Typography>
              <Table className={classes.table} style={{marginTop: 20}}>
                <TableHead style={{backgroundColor:"#f3f3f3"}}>
                  <TableRow>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">チェックアウト予定日</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">宿泊開始日</TableCell>
                    <TableCell style={{color: "#676767"}} align="right" padding="dense">泊数</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">お部屋</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">お名前</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">領収書発行</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reservationsBeforeCheckedOut.map(n =>
                    {
                      let rooms = "";
                      for(let i in n.input_rooms){
                        rooms = rooms + n.input_rooms[i]
                        if(i !== n.input_rooms.length - 1){
                          rooms = rooms + " "
                        }
                      }

                      return (
                        <TableRow key={n.reservation_id}>
                          <TableCell align="center" padding="dense">{moment(n.date).add(n.date_num, 'days').format("YYYY-MM-DD")}</TableCell>
                          <TableCell align="center" padding="dense">{n.date}</TableCell>
                          <TableCell align="right" padding="dense">{n.date_num}</TableCell>
                          <TableCell align="center" padding="dense">{rooms}</TableCell>
                          <TableCell align="center" padding="dense">{n.last_name} {n.first_name} <div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div></TableCell>
                          <TableCell align="center" padding="dense">

                            {(() => {
                               if (n.receipt_numbers.length > 0){
                                 return (
                                   <Typography color="primary" variant="body2" style={{display: "inline-flex", verticalAlign:"middle", marginTop:0}}>
                                     <CheckIcon style={{marginLeft: 0, marginTop: -1, marginRight:5}} />済
                                   </Typography>
                                 )
                               }else{
                                 return (
                                   <Typography color="error" variant="body2" style={{display: "inline-flex", verticalAlign:"middle", marginTop:0}}>
                                     <ErrorIcon style={{marginLeft: 0, marginTop: -1, marginRight:5}} />未
                                   </Typography>
                                 )
                               }
                             })()}

                          </TableCell>
                          <TableCell align="center" padding="dense">

                            <Button
                              type="submit"
                              variant="contained"
                              color="default"
                              className={classes.button}
                              onClick={() => this.handleReservationOpen(n.reservation_id)}
                              style={{marginBottom:15,marginTop:5}}
                            >
                              <ListItemIcon><SvgIcon size={18} icon={phone}/></ListItemIcon>
                              付加情報入力　
                            </Button>
                            <br/>
                            <Button
                              type="submit"
                              variant="contained"
                              color="default"
                              className={classes.button}
                              onClick={() => this.handleClickOpen(n.reservation_id, false, n.jalan_paid, n.exist_orders)}
                              style={{marginBottom:5}}
                            >
                              <ListItemIcon><SvgIcon size={18} icon={checkSquareO}/></ListItemIcon>
                              チェックアウト
                            </Button>

                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </Grid>


        <Dialog
          open={this.state.open}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-slide-title">
            チェックアウトしてよろしいですか？
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              チェックアウト処理後は、<br/>
              予約情報、オーダー情報の修正、領収書発行処理が行えません。<br/><br/>
              すべての処理の完了後にチェックアウトしてください。
            </DialogContentText>

            <Typography variant="h5" gutterBottom style={{marginTop: 50, fontSize: "1.2rem" }}>
              支払い情報入力
            </Typography>

            <Typography variant="subtitle1" gutterBottom style={{marginTop: 30, color: "#000000de"}}>
              宿泊代
            </Typography>
            <div className={classes.toggleContainer}>
              <ToggleButtonGroup value={methodOfPaymentPlans} exclusive onChange={(e, methodOfPayment) => this.handleToggle(e, methodOfPayment, "methodOfPaymentPlans")}>

                <ToggleButton value="cash" className={classes.toggleButton} disabled={methodOfPaymentPlansDone === 'yes' ? true : false}>
                  <ListItemIcon className={classes.listItemIcon}><SvgIcon size={18} icon={yen}/></ListItemIcon>現金決済
                </ToggleButton>
                <ToggleButton value="card" className={classes.toggleButton} disabled={methodOfPaymentPlansDone === 'yes' ? true : false}>
                  <ListItemIcon className={classes.listItemIcon}><SvgIcon size={18} icon={creditCard}/></ListItemIcon>クレジットカード決済
                </ToggleButton>
                <ToggleButton value="online" className={classes.toggleButton} disabled={methodOfPaymentPlansDone === 'yes' ? true : false}>
                  <ListItemIcon className={classes.listItemIcon}><SvgIcon size={18} icon={tv}/></ListItemIcon>オンライン決済
                </ToggleButton>

              </ToggleButtonGroup>
              <br/>
            </div>

            { methodOfPaymentPlansDone === 'yes' &&
              <Typography variant="body2" style={{marginLeft: 15, marginTop: 0, color: "#0000008a"}}>
                ※じゃらん支払い済みです
              </Typography>
            }

            <Typography variant="subtitle1" gutterBottom style={{marginTop: 30, color: "#000000de"}}>
              飲食代
            </Typography>
            <div className={classes.toggleContainer}>
              <ToggleButtonGroup value={methodOfPaymentOrders} exclusive onChange={(e, methodOfPayment) => this.handleToggle(e, methodOfPayment, "methodOfPaymentOrders")}>

                <ToggleButton value="cash" className={classes.toggleButton} disabled={existOrders === 'no' ? true : false}>
                  <ListItemIcon className={classes.listItemIcon}><SvgIcon size={18} icon={yen}/></ListItemIcon>現金決済
                </ToggleButton>
                <ToggleButton value="card" className={classes.toggleButton} disabled={existOrders === 'no' ? true : false}>
                  <ListItemIcon className={classes.listItemIcon}><SvgIcon size={18} icon={creditCard}/></ListItemIcon>クレジットカード決済
                </ToggleButton>

              </ToggleButtonGroup>
            </div>

            { existOrders === 'no' &&
              <Typography variant="body2" style={{marginLeft: 15, marginTop: 0, color: "#0000008a"}}>
                ※オーダーはありません
              </Typography>
            }

            <Typography variant="subtitle1" gutterBottom style={{marginTop: 30, color: "#000000de"}}>
              缶飲料代
            </Typography>

            <ValidatorForm
              ref="form"
              style={{margin: 0}}
              onSubmit={this.checkout}
            >
              <TextValidator
                className={classes.textField}
                name="drinksPrice"
                label="金額入力(税込)"
                value={drinksPrice}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'drinksPrice')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150, marginTop:0, marginBottom: 10, marginLeft: 20}}
              />
            </ValidatorForm>

            <div className={classes.toggleContainer}>
              <ToggleButtonGroup value={methodOfPaymentDrinks} exclusive onChange={(e, methodOfPayment) => this.handleToggle(e, methodOfPayment, "methodOfPaymentDrinks")}>

              <ToggleButton value="cash" className={classes.toggleButton} disabled={drinksPrice === '0' ? true : false}>
                <ListItemIcon className={classes.listItemIcon}><SvgIcon size={18} icon={yen}/></ListItemIcon>現金決済
              </ToggleButton>
              <ToggleButton value="card" className={classes.toggleButton} disabled={drinksPrice === '0' ? true : false}>
                <ListItemIcon className={classes.listItemIcon}><SvgIcon size={18} icon={creditCard}/></ListItemIcon>クレジットカード決済
              </ToggleButton>

              </ToggleButtonGroup>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              いいえ
            </Button>
            <Button onClick={this.checkout} color="primary">
              はい
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog
          open={reservationOpen}
          onClose={this.handleCloseReservation}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          maxWidth="md"
        >
          <DialogTitle id="scroll-dialog-title">顧客付加情報</DialogTitle>
          <DialogContent>
            <ValidatorForm
              ref="form"
              onSubmit={(e) => this.updateReservatiion(e)}
              onError={
                errors => {
                  console.log(errors);
                  const { enqueueSnackbar } = this.props;
                  enqueueSnackbar('入力エラーがあります。確認してください。', {variant : 'warning'});
                }
              }
            >

              <TextValidator
                className={classes.textField}
                name="customerNote"
                label="顧客の備考"
                value={customerNote}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'customerNote')}
                required={false}
                multiline={true}
                rows={3}
                style={{width:600, marginBottom: 40}}
              />

              <TextValidator
                className={classes.textField}
                name="planNote"
                label="予約の備考"
                value={planNote}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'planNote')}
                required={false}
                multiline={true}
                rows={3}
                style={{width:600, marginBottom: 40}}
              />
              <br/>
              <Typography variant="subtitle1" style={{marginBottom:20}}>
                顧客構成
              </Typography>
              <Typography variant="subtitle2" style={{display:'inline', marginRight: 135}}>
                男性
              </Typography>
              <Typography variant="subtitle2" style={{display:'inline'}}>
                女性
              </Typography>
              <br/>
              <TextValidator
                className={classes.textField}
                name="babyM"
                label="〜3歳"
                value={babyM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'babyM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="babyW"
                label="〜3歳"
                value={babyW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'babyW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="kindergartenM"
                label="幼稚園児"
                value={kindergartenM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'kindergartenM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="kindergartenW"
                label="幼稚園児"
                value={kindergartenW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'kindergartenW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="elementarySchoolLowM"
                label="小学校低学年"
                value={elementarySchoolLowM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'elementarySchoolLowM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="elementarySchoolLowW"
                label="小学校低学年"
                value={elementarySchoolLowW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'elementarySchoolLowW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="elementarySchoolMiddleM"
                label="小学校中学年"
                value={elementarySchoolMiddleM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'elementarySchoolMiddleM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="elementarySchoolMiddleW"
                label="小学校中学年"
                value={elementarySchoolMiddleW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'elementarySchoolMiddleW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="elementarySchoolHighM"
                label="小学校高学年"
                value={elementarySchoolHighM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'elementarySchoolHighM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="elementarySchoolHighW"
                label="小学校高学年"
                value={elementarySchoolHighW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'elementarySchoolHighW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="juniorHighSchoolM"
                label="中学生"
                value={juniorHighSchoolM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'juniorHighSchoolM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="juniorHighSchoolW"
                label="中学生"
                value={juniorHighSchoolW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'juniorHighSchoolW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="highSchoolM"
                label="高校生"
                value={highSchoolM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'highSchoolM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="highSchoolW"
                label="高校生"
                value={highSchoolW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'highSchoolW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="universityM"
                label="大学生(19歳-22歳)"
                value={universityM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'universityM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="universityW"
                label="大学生(19歳-22歳)"
                value={universityW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'universityW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="twentiesM"
                label="20代"
                value={twentiesM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'twentiesM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="twentiesW"
                label="20代"
                value={twentiesW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'twentiesW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="thirtiesM"
                label="30代"
                value={thirtiesM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'thirtiesM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="thirtiesW"
                label="30代"
                value={thirtiesW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'thirtiesW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="fortiesM"
                label="40代"
                value={fortiesM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'fortiesM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="fortiesW"
                label="40代"
                value={fortiesW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'fortiesW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="fiftiesM"
                label="50代"
                value={fiftiesM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'fiftiesM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="fiftiesW"
                label="50代"
                value={fiftiesW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'fiftiesW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="sixtiesM"
                label="60代"
                value={sixtiesM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'sixtiesM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="sixtiesW"
                label="60代"
                value={sixtiesW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'sixtiesW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <br/>
              <TextValidator
                className={classes.textField}
                name="overSeventiesM"
                label="70代以上"
                value={overSeventiesM}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'overSeventiesM')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <TextValidator
                className={classes.textField}
                name="overSeventiesW"
                label="70代以上"
                value={overSeventiesW}
                margin="normal"
                onChange={(e) => this.handleChange(e, 'overSeventiesW')}
                type="number"
                min="0"
                validators={['isNumber', 'minNumber:0']}
                errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                style={{width: 150}}
              />
              <Button type="submit" variant="contained" color="primary" className={classes.button} style={{marginLeft: "90%", marginTop:40}}>
                更新
              </Button>
            </ValidatorForm>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseReservation} color="primary">
              閉じる
            </Button>
          </DialogActions>
        </Dialog>


      </Fragment>
    );
  }
}

CheckedOutManage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withRouter(withStyles(styles, { withTheme: true })(CheckedOutManage)));
